import { watch, onBeforeUnmount } from 'vue'
import { logUiEvent } from '@/common/activityLog'

// The overlay arms a reason before it closes itself. A close with no armed reason comes from the host.
export default function useOverlayActivity(kind, isOpen, { target = null } = {}) {
  let reason = null
  // A route change can come before the close. Keep the page the overlay opened on.
  let openedPath = null

  const log = (event, options = {}) => logUiEvent(`${kind}_${event}`, { target, path: openedPath, ...options })

  watch(isOpen, (open, wasOpen) => {
    if (open) {
      openedPath = window.location.pathname
      logUiEvent(`${kind}_open`, { target })
    } else if (wasOpen) {
      log('close', { via: reason || 'host' })
    }
    reason = null
  }, { immediate: true })

  // A host v-if can remove an open overlay before the watch runs. The armed reason still applies.
  onBeforeUnmount(() => {
    if (isOpen()) log('close', { via: reason || 'unmount' })
  })

  return {
    armClose: (closeReason) => { reason = closeReason }
  }
}
